import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';


const textareaStyle = {
  width: "100%",
  padding: "8px",
  fontSize: "13px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  resize: "none",
  minHeight: "35px",
  boxSizing: "border-box",
};

function TableControls({
  rowsPerPage,
  setRowsPerPage,
  searchTerm,
  setSearchTerm,
  handlePrint,
  hideControls,
  printMode,
}) {
  if (hideControls || printMode) return null;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "80%",
        margin: "0 auto 15px auto",
        padding: "10px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <label style={{ fontWeight: "bold", color: "#333", alignContent: "center" }}>
          Per Page:
        </label>
        <select
          value={rowsPerPage}
          onChange={(e) =>
            setRowsPerPage(
              e.target.value === "ALL" ? "ALL" : Number(e.target.value)
            )
          }
          style={{
            padding: "6px 10px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            background: "white",
            fontSize: "14px",
          }}
        >
          {[10, 25, 50, 100, "ALL"].map((r) => (
            <option key={r} value={r}>
              {r}
            </option>
          ))}
        </select>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <button
          style={{
            background: "none",
            border: "1px solid #ccc",
            padding: "5px 8px",
            cursor: "pointer",
          }}
        >
          🧩
        </button>
        <button
          style={{
            background: "none",
            border: "1px solid #ccc",
            padding: "5px 8px",
            cursor: "pointer",
          }}
        >
          🧩
        </button>
        <button
          onClick={handlePrint}
          style={{
            backgroundColor: "#2004bdcb",
            color: "white",
            border: "none",
            padding: "8px 20px",
            borderRadius: "5px",
            cursor: "pointer",
            fontWeight: "bold",
            fontSize: "14px",
          }}
        >
          Print
        </button>

        <input
          type="text"
          placeholder="Search..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: "8px 12px",
            width: "250px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            fontSize: "14px",
          }}
        />
      </div>
    </div>
  );
}

function PrintMessage() {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.9)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          background: "white",
          color: "#333",
          padding: "30px 40px",
          borderRadius: "10px",
          textAlign: "center",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
          minWidth: "400px",
        }}
      >
        <h3 style={{ margin: "0 0 15px 0", color: "#ff6f00", fontSize: "1.5rem" }}>
          Print View
        </h3>
        <p style={{ margin: 0, fontSize: "16px", lineHeight: "1.5", color: "#555" }}>
          Please use your browser's print function to print this table.
          <br />
          Press <strong>Escape</strong> when finished.
        </p>
      </div>
    </div>
  );
}

function VroEntry() {
  const [vroList, setVroList] = useState([]);
  const [error, setError] = useState("");
  const [infoMessage, setInfoMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [printMode, setPrintMode] = useState(false);
  const [showPrintMessage, setShowPrintMessage] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [updatingRows, setUpdatingRows] = useState({});
  const [globalError, setGlobalError] = useState("");
  const [listSize, setListSize] = useState(0);
  const [loading, setLoading] = useState(true);
  const [minDelayDone, setMinDelayDone] = useState(false);

  const validateForm = (vroName, vroUid, vroMobile) => {
    if (!vroName || vroName.trim() === "" || vroName === "-NA-") {
      return "Please Enter VRO Name";
    }
    if (vroName.length > 150) {
      return "VRO Name must be up to 150 characters";
    }
    if (!vroUid || vroUid.trim() === "" || vroUid === "-NA-") {
      return "Please Enter VRO UID";
    }
    if (vroUid.length !== 12) {
      return "Please Enter Valid VRO UID (12 digits)";
    }
    if (!vroMobile || vroMobile.trim() === "" || vroMobile === "-NA-") {
      return "Please Enter VRO Mobile";
    }
    if (vroMobile.length !== 10) {
      return "Please Enter Valid VRO Mobile (10 digits)";
    }
    const firstDigit = vroMobile.charAt(0);
    if (firstDigit !== '9' && firstDigit !== '8' && firstDigit !== '7') {
      return "Invalid Phone No (must start with 7, 8, or 9)";
    }
    return null;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setMinDelayDone(true);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  const fetchVroDetails = useCallback(async () => {
    setLoading(true); // START loading

    try {
      const res = await axios.get(`${process.env.REACT_APP_URL}/api/vroList`, {
        withCredentials: true,
      });

      if (res.data) {
        if (res.data.error) {
          setGlobalError(res.data.error);
          setVroList([]);
          setListSize(0);
        } else if (Array.isArray(res.data.list)) {
          const formattedList = res.data.list.map((item, index) => ({
            id: index,
            distName: item.district_name || "-NA-",
            afsoName: item.afso_name || "-NA-",
            fpsId: item.fps_id || "-NA-",
            vroName: item.vro_name_en || "-NA-",
            vroUid: item.vro_uid || "-NA-",
            vroMobile: item.vro_mobile || "-NA-",
            vroType: item.vro_type || "-NA-",
          }));

          setVroList(formattedList);
          setListSize(res.data.list_size || formattedList.length);
          setGlobalError("");
          setInfoMessage("");
        } else {
          setVroList([]);
          setListSize(0);
          setGlobalError("No records found");
        }
      }
    } catch (err) {
      setGlobalError("Server error: " + (err.response?.data?.error || err.message));
      setVroList([]);
      setListSize(0);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVroDetails();
  }, [fetchVroDetails]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, rowsPerPage]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        setPrintMode(false);
        setShowPrintMessage(false);
      }
    };

    if (printMode) {
      window.addEventListener("keydown", handleEscape);
      return () => {
        window.removeEventListener("keydown", handleEscape);
      };
    }
  }, [printMode]);

  const checkUidExists = async (vroUid, index) => {
    console.log(`checkUidExists called for row ${index}, UID: ${vroUid}`);

    if (!vroUid || vroUid.trim() === "" || vroUid === "-NA-") {
      return true;
    }

    if (vroUid.length !== 12 || !/^\d{12}$/.test(vroUid)) {
      alert("Please enter valid 12-digit Aadhaar number");
      return false;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/checkUid`,
        null,
        {
          params: { vro_uid: vroUid },
          withCredentials: true
        }
      );

      console.log("UID check response:", response.data);

      if (response.data.error) {
        alert(response.data.error);
        return false;
      }

      return true;
    } catch (error) {
      console.error("UID check error:", error);
      const errorMsg = error.response?.data?.error || error.message || "Unknown error";
      alert(errorMsg);
      return false;
    }
  };

  const updateData = async (index) => {
    if (updatingRows[index]) return;

    const item = vroList[index];
    if (!item) {
      alert("Row data not found");
      return;
    }

    const { fpsId, vroName, vroUid, vroMobile } = item;

    const validationError = validateForm(vroName, vroUid, vroMobile);
    if (validationError) {
      alert(validationError);
      return;
    }

    const uidValid = await checkUidExists(vroUid, index);
    if (!uidValid) return;

    // mark immediately
    setUpdatingRows(prev => ({ ...prev, [index]: true }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/api/update`,
        null,
        {
          params: {
            fps_id: fpsId,
            vro_uid: vroUid,
            vro_name_en: vroName,
            vro_mobile: vroMobile
          },
          withCredentials: true,
          headers: {
            'X-React-Route': window.location.href
          }
        }
      );

      if (response.data.error) {
        alert(response.data.error);
        return;
      }

      alert(response.data.message || "VRO details updated successfully");
      fetchVroDetails();

    } catch (error) {
      const errorMsg = error.response?.data?.error || error.message;
      alert("Update failed: " + errorMsg);
    } finally {
      setUpdatingRows(prev => ({ ...prev, [index]: false }));
    }
  };
  const handlePrint = () => {
    setShowPrintMessage(true);
    setTimeout(() => {
      setShowPrintMessage(false);
      setPrintMode(true);
    }, 2000);
  };

  const filteredData = vroList.filter(item =>
    Object.values(item).some(value =>
      String(value || "").toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const totalEntries = filteredData.length;
  const totalPages = rowsPerPage === "ALL" ? 1 : Math.ceil(totalEntries / rowsPerPage);
  const startIndex = printMode || rowsPerPage === "ALL" ? 0 : (currentPage - 1) * rowsPerPage;
  const endIndex = printMode || rowsPerPage === "ALL" ? totalEntries : Math.min(startIndex + rowsPerPage, totalEntries);
  const currentData = printMode || rowsPerPage === "ALL"
    ? filteredData
    : filteredData.slice(startIndex, endIndex);

  const showLoader = loading || !minDelayDone;


  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", minHeight: "100vh" }}>
      {showPrintMessage && <PrintMessage />}

      {!printMode && (
        <>
          <div className="mainhead" style={{ textAlign: "center" }}>Enter VRO Name, UID Number, Mobile Number</div>

          {globalError && (
            <div style={{
              color: "#d8000c",
              backgroundColor: "#ffbaba",
              textAlign: "center",
              padding: "12px",
              borderRadius: "5px",
              margin: "0 auto 15px auto",
              width: "80%",
              fontWeight: "bold",
              border: "1px solid #d8000c"
            }}>
              {globalError}
            </div>
          )}

          {infoMessage && !globalError && (
            <div style={{
              color: "#00529b",
              backgroundColor: "#bde5f8",
              textAlign: "center",
              padding: "12px",
              borderRadius: "5px",
              margin: "0 auto 15px auto",
              width: "80%",
              fontWeight: "bold",
              border: "1px solid #00529b"
            }}>
              {infoMessage}
            </div>
          )}

          {error && (
            <div style={{
              color: "#9f6000",
              backgroundColor: "#feefb3",
              textAlign: "center",
              padding: "12px",
              borderRadius: "5px",
              margin: "0 auto 15px auto",
              width: "80%",
              fontWeight: "bold",
              border: "1px solid #9f6000"
            }}>
              {error}
            </div>
          )}

          {!showLoader && (
            <TableControls
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              handlePrint={handlePrint}
              printMode={printMode}
            />
          )}
        </>
      )}

      {showLoader ? (
        <div style={{ textAlign: "center", marginTop: "40px" }}>
          <CircularProgress />
        </div>
      ) : (

        <table width="90%" align="center" className="display">

          <thead>
            <tr className="tableheader">
              <th>Sl.NO</th>
              <th>District Name</th>
              <th>Office Name</th>
              <th>FPS ID</th>
              <th>VRO Name</th>
              <th>VRO UID Number</th>
              <th>VRO Mobile</th>
              <th className="no-sort">Update</th>
            </tr>

          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((item, index) => {
                return (
                  <tr key={item.id} style={{ backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white" }}>

                    <td style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #ddd" }}>
                      {item.id + 1}
                    </td>

                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>{item.distName}</td>
                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>{item.afsoName}</td>
                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>{item.fpsId}</td>

                    {/* VRO NAME */}
                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>
                      <textarea
                        value={item.vroName}
                        disabled={printMode}
                        onChange={(e) => {
                          const list = [...vroList];
                          list[item.id].vroName = e.target.value;
                          setVroList(list);
                        }}
                        style={textareaStyle}
                      />
                    </td>

                    {/* UID */}
                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>
                      <textarea
                        value={item.vroUid}
                        disabled={printMode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "").slice(0, 12);
                          const list = [...vroList];
                          list[item.id].vroUid = value;
                          setVroList(list);
                        }}
                        style={textareaStyle}
                      />
                    </td>

                    {/* MOBILE */}
                    <td style={{ padding: "10px 8px", border: "1px solid #ddd" }}>
                      <textarea
                        value={item.vroMobile}
                        disabled={printMode}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, "").slice(0, 10);
                          const list = [...vroList];
                          list[item.id].vroMobile = value;
                          setVroList(list);
                        }}
                        style={textareaStyle}
                      />
                    </td>

                    {/* UPDATE BUTTON */}
                    <td style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #ddd" }}>
                      <button
                        onClick={() => updateData(item.id)}
                        disabled={updatingRows[item.id]}
                        style={{
                          background: updatingRows[item.id] ? "#666" : "black",
                          color: "white",
                          border: "none",
                          borderRadius: "12px",
                          padding: "8px 20px",
                          cursor: updatingRows[item.id] ? "not-allowed" : "pointer",
                        }}
                      >
                        UPDATE
                      </button>
                    </td>

                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={8} style={{ textAlign: "center", padding: "20px" }}>
                  <div className="response">No matching records found</div>
                </td>
              </tr>
            )}
          </tbody>

        </table>
      )}

      {!printMode && !showLoader && (
        <div style={{
          width: "80%",
          margin: "20px auto",
          padding: "15px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
          <div style={{ color: "darkred", fontSize: "15px" }}>
            Showing {filteredData.length > 0 ? `${startIndex + 1} to ${Math.min(endIndex, filteredData.length)}` : '0 to 0'}
            of {filteredData.length} entries
            {listSize > 0 && ` (filtered from ${listSize} total entries)`}
          </div>
          <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
            <button
              disabled={currentPage === 1 || filteredData.length === 0}
              onClick={() => setCurrentPage(1)}
              style={{
                padding: "6px 12px",
                minWidth: "60px",
                border: "1px solid #2004bdcb",
                background: (currentPage === 1 || filteredData.length === 0) ? "#666" : "#2004bdcb",
                color: "white",
                cursor: (currentPage === 1 || filteredData.length === 0) ? "not-allowed" : "pointer",
                borderRadius: "4px",
                fontWeight: "bold",
                opacity: (currentPage === 1 || filteredData.length === 0) ? 0.7 : 1,
              }}
            >
              First
            </button>
            <button
              disabled={currentPage === 1 || filteredData.length === 0}
              onClick={() => setCurrentPage(currentPage - 1)}
              style={{
                padding: "6px 12px",
                minWidth: "60px",
                border: "1px solid #2004bdcb",
                background: (currentPage === 1 || filteredData.length === 0) ? "#666" : "#2004bdcb",
                color: "white",
                cursor: (currentPage === 1 || filteredData.length === 0) ? "not-allowed" : "pointer",
                borderRadius: "4px",
                fontWeight: "bold",
                opacity: (currentPage === 1 || filteredData.length === 0) ? 0.7 : 1,
              }}
            >
              Prev
            </button>
            <span style={{ margin: "0 15px", color: "#333", fontWeight: "bold" }}>
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              disabled={currentPage === totalPages || filteredData.length === 0}
              onClick={() => setCurrentPage(currentPage + 1)}
              style={{
                padding: "6px 12px",
                minWidth: "60px",
                border: "1px solid #2004bdcb",
                background: (currentPage === totalPages || filteredData.length === 0) ? "#666" : "#2004bdcb",
                color: "white",
                cursor: (currentPage === totalPages || filteredData.length === 0) ? "not-allowed" : "pointer",
                borderRadius: "4px",
                fontWeight: "bold",
                opacity: (currentPage === totalPages || filteredData.length === 0) ? 0.7 : 1,
              }}
            >
              Next
            </button>
            <button
              disabled={currentPage === totalPages || filteredData.length === 0}
              onClick={() => setCurrentPage(totalPages)}
              style={{
                padding: "6px 12px",
                minWidth: "60px",
                border: "1px solid #2004bdcb",
                background: (currentPage === totalPages || filteredData.length === 0) ? "#666" : "#2004bdcb",
                color: "white",
                cursor: (currentPage === totalPages || filteredData.length === 0) ? "not-allowed" : "pointer",
                borderRadius: "4px",
                fontWeight: "bold",
                opacity: (currentPage === totalPages || filteredData.length === 0) ? 0.7 : 1,
              }}
            >
              Last
            </button>
          </div>
        </div>
      )}

      {printMode && (
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            backgroundColor: "#ff6f00ff",
            color: "white",
            border: "none",
            padding: "10px 15px",
            borderRadius: "20px",
            cursor: "pointer",
            fontWeight: "bold",
            boxShadow: "0 4px 6px rgba(0,0,0,0.2)",
            zIndex: 3000,
          }}
        >
          Top
        </button>
      )}
    </div>
  );
}

export default VroEntry;